import { OnInit, AfterViewInit, Component, ViewChild, ViewContainerRef, ElementRef, ViewEncapsulation, Input } from "@angular/core";
import { Observable, Observer ,  noop, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ICellRendererAngularComp, ICellEditorAngularComp } from "ag-grid-angular";
import { ICellEditorParams, ICellRendererParams } from "ag-grid-community";

import { DataService, ITypeAsync } from './data.service';

@Component({
    selector: 'typeahead-cell',
    encapsulation: ViewEncapsulation.None,
    host: { style: `position: absolute;
					left: 0px; 
					top: 0px;
					background-color: transparent;
					` },
    template: `
           <input #newitemDesc class="item-grid-input" [(ngModel)]="value" style="height:28px" [style.width]="params.column.actualWidth + 'px'" placeholder="start typing your items to activate autofill"
                [typeahead]="suggestions$['ItemName']"  typeaheadOptionField="name" [typeaheadAsync]="true" [typeaheadOptionsLimit]="20" (typeaheadOnSelect)="onItemSelect($event)" autocomplete="off">
    `,
    styles: [
        `.ag-root-wrapper {overflow-y: visible !important}
        `
    ]
})
export class TypeaheadEditor implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: string;
    public text: string;
    private cancelBeforeStart: boolean = false;
    private cancelAfterEnd: boolean = false;

    suggestions$: ITypeAsync = {};
    typeable: string[] = ['ItemName'];

    @ViewChild('newitemDesc', { static: false }) public input: ElementRef;

    constructor(private dataService: DataService) { }

    agInit(params: ICellEditorParams): void {
        this.params = params;
        this.text = this.params.value;
        this.value = this.params.value;

        for (var f of this.typeable)
            this.suggestions$[f] = this.setAsync(f);
    }

    setAsync(field: string): Observable<any> {
        return new Observable((observer: Observer<string>) => {
            observer.next(this.value);
        }).pipe(
            switchMap((query: string) => {
                if (query) {
                    //this.errorMessage = '';
                    return this.dataService.getTypeahead(query)
                        .pipe(
                            tap((v) => {
                                if (v && v.length > 0)
                                    this.params.context.selectedItems[this.params.rowIndex] = v[0];
                            }, err => {
                                //this.errorMessage = this.dataService.processError(err);
                            })
                        );
                }

                return of([]);
            })
        );
    }

    getValue(): any {
        return this.value;
    }

    isCancelBeforeStart(): boolean {
        return this.cancelBeforeStart;
    }

    isCancelAfterEnd(): boolean {
        return this.cancelAfterEnd;
    };

    onItemSelect(event): void {
        this.value = event.item.name;
        this.params.context.selectedItems[this.params.rowIndex] = event.item;
        setTimeout(() => this.params.api.stopEditing());

    //    if (this.params.onAdded && this.value) {
    //        var f = this.params.onAdded.bind(this.params.context);
    //        setTimeout(() => f());
    //    }
    }

    //onChanged(ev) {
    //    if (this.text != this.value)
    //        this.params.context.selectedItems[this.params.rowIndex] = null;
    //}

    isPopup(): boolean {
        return true;
    }

    focusIn() {
        if (this.params.focus)
            this.input.nativeElement.focus();
    }

    ngAfterViewInit() {
        if (this.params.focus)
            setTimeout(() => {
                this.input.nativeElement.focus();
            })
    }
}

@Component({
    selector: 'imei-popup',
    template: `
        <div class="modal-header">
          <h4 class="modal-title pull-left">{{req?.name}}</h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div style="color:red;font-size:1.1em">{{errmsg}}</div>
            <table class="table table-condensed">
                <tr *ngFor="let im of items"><td><input type="text" [(ngModel)]="im.reqValue" [ngClass]="im.css"></td></tr>
            </table>
            <div style="margin:15px 10px 10px 0">
                <input id="imeiOKButton" type="button" value="OK" class="btn btn-primary" (click)="done()" [disabled]="!valid" />
            </div>
        </div>
     `,
    styles: [
        `
        .no-hscode {border: 2px solid #a94442;}
        `
    ]
})
export class IMEIPopupComponent implements OnInit {
    public items: any[] = [];
    @Input() req: any;
    @Input() quantity: number;
    errmsg: string = '';

    constructor(public bsModalRef: BsModalRef) { }

    ngOnInit(): void {
    }

    show(): void {
        for (var i = 0; i < this.quantity; i++)
            this.items.push({ name: this.req.name, reqValue: '', css: '' });
    }

    get valid() {
        return this.items.every(x => !!x.reqValue);
    }

    done() {
        for (var el of this.items) {
            if (this.req.size && el.reqValue.length != this.req.size) {
                this.errmsg = `Item length has to be ${this.req.size} characters`;
                el.css = 'input-validation-error';
                return;
            }
            if (this.req.type && this.req.type.toUpperCase() == 'NUMBER' && isNaN(Number(el.reqValue))) {
                this.errmsg = `Item has to be numeric`;
                el.css = 'input-validation-error';
                return;
            }
            el.css = '';
        }
        this.bsModalRef.hide();
    }
}

@Component({
    selector: 'full-width-row',
    template: `
            <div class="full-width-panel">
                <div class="full-width-summary">
                    <label><b>{{data.requirements[0].name}}</b><input type="text" class="full-width-input" id="{{'reqValue'+params.rowIndex}}" [(ngModel)]="value" (ngModelChange)="modelChanged($event)"></label><br/>    
                </div>  
            </div>    `,
    styles: [
        `
    .typeahead__result {
        position: absolute;
        top: 25px;
    }
    .full-width-panel {
        white-space: normal;
        display: inline-block;
        height: 100%;
        width: 100%;
        border: 2px solid grey;
        border-style: ridge;
        padding-left: 5px;
        background-color: darkgray;
    }
    .full-width-panel label {
        margin-bottom: 0;
    }
        .full-width-panel input {
            height: 100%;
            margin-left: 10px;
        }
        `
    ]
})
export class FullWidthCellRenderer implements ICellRendererAngularComp {
    public data: any;
    public params: ICellRendererParams;
    public value;

    agInit(params: ICellRendererParams): void {
        this.data = params.node.data;
        this.params = params;
        this.value = this.data.requirements[0].reqValue;
    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }

    modelChanged(v: any) {
        var ix = this.params.rowIndex;
        this.params.context.rowData2[ix - 1].extData = this.params.context.rowData2[ix].requirements;
        this.params.context.rowData2[ix - 1].extData[0].reqValue = v;
        //this.params.context.rowData2 = this.params.context.rowData2.concat([{ groupname: '', description: '', weight: '', value: '', quantity: '', seqno: this.params.context.rowData2.length }]);
        //this.params.api.setRowData(this.params.context.rowData2);
    }
}
